import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { Switch, Route, Link, useLocation } from "react-router-dom";

import Application from "../components/Application";
import ApplicationForm from "../components/ApplicationForm";
import "./../styles/Career.scss";
import leftmenuicon from "./../img/left-menu-icon-mobile.png";
import Api from "../common/api";

const Career = () => {

  const [tabs, setTabs] = useState([
    {
      id: 1,
      Name: "Sanko Enerji İK Politikası",
      content: "",
    },
    {
      id: 2,
      Name: "Sanko Enerji Kariyer Fırsatları",
      content: [
        {
          id: 32,
          title: "Sistem Destek Uzmanı",
          requirements:
            "Üniversitelerin 4 yıllık Bilgisayar bölümünden mezun <br /><br/>Bilgisayar konusunda en az 2 yıl kurumsal şirket deneyimi bulunan<br /><br />Tercihen İngilizce bilen<br /><br />Ekip çalışmasına yatkın, araştırma ve öğrenmeye istekli",
        },
      ],
    },
  ]);

  const lang = localStorage.getItem("lang");
  const [Paths, setPaths] = useState(useLocation().pathname.split("/"));
  let size = 2;
  if(lang == "en"){
    size = 3;
  }
  const [activePath, setActivePath] = useState(
    useLocation().pathname.split("/")[size]
  );
  
  const [currentTab, setCurrentTab] = useState(tabs[0]);
  const [isMobileActive, setIsMobileActive] = useState(true);
  const [banner, setBanner] = useState([]);

  React.useEffect(() => {
    
      Api.get("/home/getmenu?slug=" + Paths[size-1]).then((res) => {
      setTabs(res.data.items);
      setBanner(res.data.banner);
      if(lang == "en"){
        setCurrentTab(
          res.data.items[res.data.items.findIndex((x) => x.Link_EN == activePath)]
        );
      }else{
        setCurrentTab(
          res.data.items[res.data.items.findIndex((x) => x.Link == activePath)]
        );
      }
      
    });
  
  }, [activePath]);

  let settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 5,
    initialSlide: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const adClick = (id) => {
    const tab = tabs.find((tab) => tab.id === id);
    setCurrentTab(tab);
    setIsMobileActive(true);
  };

  const renderTitle = () => {
    if (currentTab) {
      if (lang == "en"){
        return <h3>{currentTab.Name_EN}</h3>;
      }else{
        {
          return <h3>{currentTab.Name}</h3>;
        }
      }
    }
  };

  function RenderData(tab) {
    if (tab.content.id) {
      if (tab.content.id === 1053) {
        return (
          <div className="sustanibility-container container-sm">
            {renderTitle(tab.Name)}
            
            {lang == "en" ? (
            tab.content.content.Content_EN ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: tab.content.content.Content_EN,
                }}
              ></div>
              
            ) : null

            ):(
              tab.content.content ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: tab.content.content.Content_TR,
                  }}
                ></div>
              ) : null
            )}
            <br/>
            <Application />
            <ApplicationForm />
          </div>
        );
      }
      return (

        lang == "en" ? (
        <div className="career-container container-sm">
          {renderTitle(tab.Name_EN)}
          {tab.content.content ? (
            <div
              dangerouslySetInnerHTML={{
                __html: tab.content.content.Content_EN,
              }}
            ></div>
          ) : null}
        </div>
        ):( <div className="career-container container-sm">
        {renderTitle(tab.Name)}
        {tab.content.content ? (
          <div
            dangerouslySetInnerHTML={{
              __html: tab.content.content.Content_TR,
            }}
          ></div>
        ) : null}
      </div>)
      );
    } else {
      return "";
    }
  }

  return (
    <>
      <header
        className="contact-header"
        style={{
          backgroundImage:
            `url("https://sankoenerji.com.tr` + banner + `")`,
        }}
      ></header>
      <div className="slider-deneme career-slider">
        <Slider className="slider-tab" {...settings}>
          {tabs
            ? tabs.map((tab) => {
                return (
                  <Link
                    className={currentTab.id === tab.id ? "tab active" : "tab"}
                    key={tab.id}
                    to={ lang == "en" ? "/en/" + Paths[size-1] + "/" +  tab.Link_EN : "/" + Paths[size-1] + "/" +  tab.Link }
                    onClick={() => adClick(tab.id)}
                  >
                    {lang == "en" ? tab.Name_EN : tab.Name}
                  </Link>
                );
              })
            : null}
        </Slider>
      </div>
      <div className="breadcrumbz container-sm ">
      {lang == "en" ? (
          <ol>
            <li>
              <Link to="/en">
                Homepage <span>&gt;</span>
              </Link>
            </li>
            <li>
              <a href="/en/career/Our-Human-Resources-Policy">
                Career <span>&gt;</span>
              </a>
            </li>
            <li>
              <Link to="/en/career">
                {tabs.length > 0 || currentTab.id ? (
                  <Link to={Paths[size]}>{renderTitle()}</Link>
                ) : null}
              </Link>
            </li>
          </ol>
      ) : (<ol>
        <li>
          <Link to="/">
            Anasayfa <span>&gt;</span>
          </Link>
        </li>
        <li>
          <a href="/kariyer/ik-politikasi">
            Kariyer <span>&gt;</span>
          </a>
        </li>
        <li>
          <Link to="/career">
            {tabs.length > 0 || currentTab.id ? (
              <Link to={Paths[size-1]}>{renderTitle()}</Link>
            ) : null}
          </Link>
        </li>
      </ol>)}
        
      </div>
      <button
        onClick={() => setIsMobileActive(!isMobileActive)}
        className={!isMobileActive ? "mobile-toggle" : "mobile-toggle deactive"}
      >
        <img src={leftmenuicon} alt="sada" />
      </button>
      <div
        className={
          isMobileActive
            ? "mobile-tabs-corporate active"
            : "mobile-tabs-corporate"
        }
      >
        <ul>
          {tabs
            ? tabs.map((tab) => {
                return (
                  <li
                    className={currentTab.id === tab.id ? "active" : null}
                    onClick={() => adClick(tab.id)}
                    key={tab.id}
                  >
                    <span>{lang == "en" ? tab.Name_EN : tab.Name}</span>
                  </li>
                );
              })
            : null}
        </ul>
      </div>
      <Route>
        <RenderData content={currentTab} />
      </Route>
    </>
  );
};

export default Career;
